import { render, staticRenderFns } from "./categoriesPricesGraphics.vue?vue&type=template&id=6ea3b41e"
import script from "./categoriesPricesGraphics.vue?vue&type=script&lang=js"
export * from "./categoriesPricesGraphics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports